




































































































































import Vue from 'vue';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

import { equals, clone, pluck, sort } from 'ramda';

export default Vue.extend({
  components: {
    Multiselect,
  },
  props: {
    value: {
      type: [Object, String, Array, Number],
      default: null
    },
    internalSearch: {
      type: Boolean,
      default: true
    },
    options: {
      type: Array,
    },
    multiple: {
      type: Boolean,
    },
    trackBy: {
      type: String
    },
    label: {
      type: String
    },
    searchable: {
      type: Boolean,
      default: true
    },
    clearOnSelect: {
      type: Boolean,
      default: true
    },
    hideSelected: {
      type: Boolean,
    },
    placeholder: {
      type: String,
    },
    allowEmpty: {
      type: Boolean,
      default: true
    },
    resetAfter: {
      type: Boolean,
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    customLabel: {
      type: Function,
    },
    taggable: {
      type: Boolean,
    },
    tagPlaceholder: {
      type: String,
    },
    tagPosition: {
      type: String,
    },
    max: {
      type: [Number, Boolean],
    },
    id: { },
    optionsLimit: {
      type: Number,
    },
    groupValues: {
      type: String
    },
    groupLabel: {
      type: String
    },
    groupSelect: {
      type: Boolean,
    },
    blockKeys: {
      type: Array,
    },
    preserveSearch: {
      type: Boolean,
    },
    preselectFirst: {
      type: Boolean,
    },
    showPointer: {
      type: Boolean,
      default: true
    },
    optionHeight: {
      type: Number,
    },
    name: {
      type: String,
      default: 'multiselect'
    },
    helpBlockClass: [Object, String, Function, Array],
    helpBlock: {
      type: String,
    },
    selectLabel: {
      type: String,
    },
    selectGroupLabel: {
      type: String,
    },
    selectedLabel: {
      type: String,
    },
    deselectLabel: {
      type: String,
    },
    deselectGroupLabel: {
      type: String,
    },
    showLabels: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 99999
    },
    maxHeight: {
      type: Number,
    },
    limitText: {
      type: Function,
    },
    loading: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
    openDirection: {
      type: String,
    },
    showNoOptions: {
      type: Boolean,
      default: true
    },
    showNoResults: {
      type: Boolean,
      default: true
    },
    tabindex: {
      type: Number,
    },
    valueKey: String,
    sortOptionKey: {
      type: String,
      default: 'label'
    },
    sortOptions: {
      type: Boolean,
      default: true
    },
    sortTags: {
      type: Boolean,
      default: false
    },
    customSort: {
      type: Function,
    }
  },
  data () {
    return {
      internalVal: null as any,
    }
  },
  mounted() {
    const vm = this as any;
    vm.internalVal = this.valueKey ? vm.getValueFromOptions(this.options, this.valueKey, this.value) : clone(this.value);
  },
  watch: {
    value: function(newVal: any) {
      const vm = this as any;
      vm.internalVal = vm.valueKey ? vm.getValueFromOptions(vm.options, vm.valueKey, newVal) : clone(newVal);
    },
  },
  methods: {
    handleInput(val: any) {
      const vm = this as any;
      const valToEmit = vm.getValueToEmit(val);
      this.$emit('input', valToEmit);
    },

    handleRemove(...args: any) {
      const vm = this as any;
      if (!this.multiple) {
        this.$emit('remove', ...args);
      } else {
        const valToRemove = args[0];
        if (typeof valToRemove === 'object') {
          vm.internalVal = vm.internalVal.filter((val: any) => {
            return !equals(Object.values(val), Object.values(valToRemove));
          })
        } else {
          vm.internalVal = vm.internalVal.filter((val: any) => {
            return val !== valToRemove;
          });
        }
        this.$emit('input', vm.getValueToEmit(vm.internalVal));
        this.$emit('remove', ...args);
      }
    },
    getValueToEmit(val: any) {
      const safeVal = clone(val);
      let valToEmit;
      if (this.valueKey) {
        if (safeVal === null) {
          return null;
        }
        valToEmit = this.multiple ? safeVal.map((some: any) => some[this.valueKey]) : safeVal[this.valueKey];
      } else {
        valToEmit = safeVal;
      }

      return valToEmit;
    },
    getValueFromOptions(options: any[], key: any, val: any) {
      const returnVal = clone(options).filter((option: any) => {
        if (this.multiple) {
          return !!val.filter((some: any) => {
            return option[key] === some;
          }).length;
        } else {
          return option[key] === val;
        }
      });

      if (this.multiple) {
        return returnVal;
      } else {
        return returnVal[0];
      }
    },
    processedValues(selection: any[]) {
      const vm = this as any;
      return vm.sortTags ? vm.sortByLabel(selection) : selection;
    },
    sortByLabel(values: any[]) {
      const vm = this as any;
      let lables = values.map((obj: any) => {
        return {
          label: (this.customLabel && this.customLabel(obj).toLowerCase()) || (vm.sortOptionKey && obj[vm.sortOptionKey]) || (vm.label && obj[vm.label].toLowerCase()) || (obj.label && obj.label.toLowerCase()) || obj.toLowerCase(),
          obj,
        }
      }, {});

      let sortFn = null as any;
      if (vm.customSort) {
        sortFn = vm.customSort;
      } else {
        sortFn = (a: any, b: any) => {
          if (a.label === b.label) {
            return 0;
          }
          return a.label > b.label ? 1 : -1;
        };
      }

      lables = sort(sortFn, lables);
      return pluck('obj', lables)
    },
    getOptionLabel (option: any) {
      const vm = this as any;
      if (vm.isEmpty(option)) return ''
      if (option.isTag) return option.label
      if (option.$isLabel) return option.$groupLabel

      let label = (this.customLabel && this.customLabel(option, this.label)) || option[vm.label] || option.label || option;
      if (vm.isEmpty(label)) return ''
      return label
    },
    isEmpty (opt: any) {
      if (opt === 0) return false
      if (Array.isArray(opt) && opt.length === 0) return true
      return !opt
    },
    removeElement(option: any) {
      const vm = this as any;
      vm.handleRemove(option)
    }
  },
  computed: {
    sortedOptions(): any[] {
      const vm = this as any;
      if (!vm.sortOptions) {
        return vm.options;
      } else {
        return vm.sortByLabel(vm.options);
      }
    },
    internalValue () {
      return this.value || this.value === 0
        ? Array.isArray(this.value) ? this.value : [this.value]
        : []
    },
    visibleValues () {
      const vm = this as any;
      return this.multiple ? vm.internalValue.slice(0, this.limit) : []
    },
  }
});
